var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-location3';
                    var viewUrl = 'sprite.svg#view-icon-location3';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 32 32',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };